module.exports = __webpack_public_path__ + "img/u1182.1527a480.svg";